module.exports = __webpack_public_path__ + "static/media/empty-score-assessment.274d6750.svg";